/** Config tuning approach for optimize preview/jobs. */
export type OptimizationApproach = 'BASELINE' | 'PACE' | 'MULTISTAGE-PACE' | 'MUTATIONS';

export const CONFIG_TUNING_APPROACH_OPTIONS: OptimizationApproach[] = ['BASELINE', 'MULTISTAGE-PACE', 'MUTATIONS'];

export const OPTIMIZATION_APPROACH_LABELS: Record<OptimizationApproach, string> = {
  BASELINE: 'Baseline',
  PACE: 'PACE',
  'MULTISTAGE-PACE': 'Multistage',
  MUTATIONS: 'Mutations',
};

export function normalizeOptimizationApproach(value: unknown): OptimizationApproach {
  const upper = typeof value === 'string' ? value.trim().toUpperCase() : '';
  if (upper === 'BASELINE') return 'BASELINE';
  if (upper === 'PACE') return 'PACE';
  if (upper === 'MUTATIONS') return 'MUTATIONS';
  if (upper === 'MULTISTAGE-PACE') return 'MULTISTAGE-PACE';
  return 'MULTISTAGE-PACE';
}

export function isMutationsApproach(approach: unknown): boolean {
  return normalizeOptimizationApproach(approach) === 'MUTATIONS';
}
